import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ROUTE_PATH } from "../../helper/Constants";

const Help = () => {
  const contacts = useSelector((state) => state.contacts.contacts);
  return (
    contacts?.whatsApps?.[0] && (
      <Box
        sx={{
          position: "sticky",
          bottom: "50px",
          right: "50px",
          marginLeft: "auto",
          zIndex: 1002,
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
        }}
      >
        <Link
          target="_blank"
          to={
            ROUTE_PATH.WHATSAPP +
            contacts.whatsApps[0].replace(/\s/g, "") +
            "?text=I Need Help"
          }
          about="_blank"
          style={{ textDecoration: "none", color: "#fff" }}
        >
          <img
            src="./images/Whatsapp.png"
            alt="help?"
            width={60}
            height={60}
          ></img>
        </Link>
      </Box>
    )
  );
};

export default Help;
